type SpinnerSize = 'sm' | 'md';

const sizeClasses: Record<SpinnerSize, string> = {
  sm: 'w-6 h-6 border-2',
  md: 'w-8 h-8 border-4',
};

export function Spinner({ size = 'md' }: { size?: SpinnerSize }) {
  return (
    <div
      className={`${sizeClasses[size]} border-primary border-t-transparent rounded-full animate-spin`}
    />
  );
}
